// Components
import App from './App.vue'

// Composables
import { createApp } from 'vue'


// Plugins
import { registerPlugins } from '@/plugins'
import { Can, abilitiesPlugin } from '@casl/vue';
import userStore from '@/store/user'

import "./main.scss"
const app: any = createApp(App)
registerPlugins(app)

const user = userStore()
user.defineAbilities()
app.use(abilitiesPlugin, user.ability, {
    useGlobalProperties: true
}).component(Can.name, Can)
app.config.devtools = true
app.mount('#app')